module.exports = __webpack_public_path__ + "img/samsung-white.ad1fb24.svg";